import { createContext, useContext, useState, useEffect, useCallback } from 'react';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

const SiteContentContext = createContext({ content: {}, contact: null });

export function SiteContentProvider({ children }) {
  const [content, setContent] = useState({});
  const [contact, setContact] = useState(null);

  useEffect(() => {
    // Use native fetch to avoid any axios/CORS/credentials issues
    fetch(`${API_BASE}/api/public/content`)
      .then(r => r.json())
      .then(data => {
        if (data?.content) setContent(data.content);
      })
      .catch(err => console.warn('Content fetch failed:', err));

    fetch(`${API_BASE}/api/public/contact`)
      .then(r => r.json())
      .then(data => {
        if (data?.id || data?.phone) setContact(data);
      })
      .catch(err => console.warn('Contact fetch failed:', err));
  }, []);

  return (
    <SiteContentContext.Provider value={{ content, contact }}>
      {children}
    </SiteContentContext.Provider>
  );
}

export function useSiteContent() {
  return useContext(SiteContentContext);
}

export function useContentValue() {
  const { content } = useContext(SiteContentContext);
  return useCallback(
    (key, fallback = '') => content[key] || fallback,
    [content]
  );
}
